import { MessageBox, Notification } from 'element-ui';
import { GetInfoByToken } from '@/api/basis';
import { GetSystemCustomerInfo } from '@/api/user';
import router from '@/router';
import store from '@/store';

const state = {
  userInfo: {},
  adminInfo: {}
};

const mutations = {
  // 退出登录
  signOut: (state, path) => {
    // 移除特定缓存数据
    localStorage.removeItem('token');
    // 清除state中数据
    state.userInfo = {};
    store.commit('common/resetState');
    store.commit('permission/resetState');

    // 跳转至登录页
    router.push({
      name: 'login'
    });
  }
};

const actions = {
  // 获取用户信息
  getUserInfo: ({ dispatch, commit, state }) => {
    return new Promise(resolve => {
      GetInfoByToken().then(async res => {
        if (res) {
          state.userInfo = res.data;
          localStorage.setItem('customer_id', res.data.customer_id);
          await store.dispatch('message/createWebSocket');
          dispatch('getUserBind');
        }

        resolve();
      });
    });
  },
  // 获取用户绑定信息给出提示
  getUserBind: ({ dispatch, commit, state }) => {
    let { mobile, email, wechat_open_id } = state.userInfo;
    let systemBindSet = store.getters.systemSetData.operation_safe.bind_notice;

    let hintText = '';
    if (systemBindSet.includes('mobile')) {
      if (!mobile) {
        hintText = '手机号码';
      }
    }
    if (systemBindSet.includes('email')) {
      if (!email) {
        if (hintText) {
          hintText = '、邮箱账号';
        } else {
          hintText = '邮箱账号';
        }
      }
    }
    if (systemBindSet.includes('wechat')) {
      if (!wechat_open_id) {
        if (hintText) {
          hintText = '、微信账号';
        } else {
          hintText = '微信账号';
        }
      }
    }

    let showBindNotice = localStorage.getItem('showBindNotice');
    if (hintText && showBindNotice) {
      localStorage.setItem('showBindNotice', '');
      let noticeText = `您好，平台检测到您当前未绑定${hintText}，为了更好的使用平台并及时收到来自平台和设备的消息，建议您通过用户头像下拉进入安全设置绑定${hintText}。`;

      Notification({
        title: '系统通知',
        message: noticeText,
        position: 'bottom-right'
      });
    }
  },
  // 获取管理员信息
  getSystemCustomerInfo({ commit, state }) {
    return new Promise(resolve => {
      GetSystemCustomerInfo().then(res => {
        state.adminInfo = res.data;
        resolve();
      });
    });
  },
  // 校验用户是否已绑定手机
  checkUserBindMobile({ commit, state }) {
    return new Promise(resolve => {
      if (state.userInfo.mobile) {
        resolve(true);
      } else {
        MessageBox.confirm(
          '平台针对此操作开启了手机验证码的安全校验，您当前账号未绑定手机号码无法继续，建议您马上绑定手机号码。',
          '提示',
          {
            confirmButtonText: '马上绑定',
            cancelButtonText: '暂不绑定',
            type: 'warning'
          }
        )
          .then(() => {
            router.push({
              name: 'personalCenter',
              query: {
                type: 1
              }
            });
          })
          .catch(() => {
            resolve(false);
          });
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
